"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.externalLinkComponent = exports.ExternalLinkComponent = void 0;
const app_1 = require("app");
class ExternalLinkComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.external-link, .external-link-wrapper';
    }
    OnInit() {
        this.el.forEach(el => {
            const isWrapper = el.classList.contains('external-link-wrapper');
            const iconClasses = app_1.AttrService.data(el, 'icon-class');
            if (isWrapper) {
                const links = el.querySelectorAll('a');
                if (links && links.length > 0) {
                    links.forEach(link => this.initExternalLinkIcon(link, iconClasses));
                }
                return;
            }
            this.initExternalLinkIcon(el, iconClasses);
        });
    }
    initExternalLinkIcon(link, iconClasses) {
        const externalLink = new app_1.ExternalLink();
        const isExternal = externalLink.isExternal(link);
        if (isExternal) {
            externalLink.insertIcon(link, iconClasses);
        }
    }
}
exports.ExternalLinkComponent = ExternalLinkComponent;
exports.externalLinkComponent = new ExternalLinkComponent();
